import http from '../http'

export default {
  retryTransaction (disbursement) {
    return http.post('/bongapoints/retry', disbursement)
  }
}
